/**
 * Biometric capture standards - shared constants and guidance across
 * registration, approval, and profile update flows.
 */

// Video constraints - consistent resolution for Rekognition quality
export const BIOMETRIC_VIDEO_CONSTRAINTS = {
  width: 480,
  height: 480,
  facingMode: 'user',
};

// Screenshot format
export const BIOMETRIC_SCREENSHOT_FORMAT = 'image/jpeg';

// User guidance (used across all capture flows)
export const BIOMETRIC_GUIDANCE = {
  positioning: 'Position your face in the center of the circle.',
  tips: 'Ensure good lighting. Face the camera squarely. Avoid strong shadows or glare.',
  retry: 'If verification fails, try again with better lighting and a neutral expression.',
};
